import { Component } from '@angular/core';
import { IdentityService } from '../identity.service';

@Component({
  selector: 'lib-invalid-domain',
  templateUrl: './invalid-domain.component.html',
  styleUrls: ['./invalid-domain.component.scss'],
})
export class InvalidDomainComponent {
  constructor(private identityService: IdentityService) {}

  logout() {
    this.identityService.logout(false);
  }
}
